import { styled } from '@mui/system';
import { Typography } from '@mui/material';

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
});

const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: 600,
  color: '#414046',
  lineHeight: '24px',
  textAlign: 'left',
  margin: '12px 0px 12px 12px',
});

const DirectionContainer = styled('div')({
  display: 'flex',
  gap: '5px',
  marginTop: '10px',
});

const PaddingContainer = styled('div')({
  padding: '12px 15px',
});

const InformationTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.16px',
  textAlign: 'left',
  color: '#757475',
  '> span': {
    fontWeight: 500,
    color: '#414046',
    marginRight: '5px',
  },
});

const InlineContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: '5px',
});

export {
  RootDiv,
  TitleTypography,
  DirectionContainer,
  InformationTypography,
  PaddingContainer,
  InlineContainer,
};
